import React from "react";
import RulesSimulatorList from "@/presentation/pages/rules-simulator/rules-simulator-list";
import { useParams } from "react-router-dom";
const RulesSimulatorListWrapper = () => {
    const params = useParams();
    const ruleID = (params === null || params === void 0 ? void 0 : params.ruleID) && parseInt(params === null || params === void 0 ? void 0 : params.ruleID, 10) ? parseInt(params === null || params === void 0 ? void 0 : params.ruleID, 10) : 0;
    return React.createElement(RulesSimulatorList, { ruleID: ruleID });
};
export default RulesSimulatorListWrapper;
